"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentStatus = void 0;
var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["DRAFT"] = "DRAFT";
    ShipmentStatus["CREATED"] = "CREATED";
    ShipmentStatus["SCHEDULED"] = "SCHEDULED";
    // we are not going "ing" route
    ShipmentStatus["SUBMITTED"] = "SUBMITTED";
    ShipmentStatus["PROCESSING"] = "PROCESSING";
    ShipmentStatus["READY_TO_SHIP"] = "READY_TO_SHIP";
    ShipmentStatus["SHIPPED"] = "SHIPPED";
    ShipmentStatus["DELIVERED"] = "DELIVERED";
    ShipmentStatus["ARRIVED"] = "ARRIVED";
    ShipmentStatus["RECEIVING"] = "RECEIVING";
    ShipmentStatus["COMPLETED"] = "COMPLETED";
    ShipmentStatus["CANCELLED"] = "CANCELLED";
    ShipmentStatus["ERROR"] = "ERROR";
})(ShipmentStatus || (exports.ShipmentStatus = ShipmentStatus = {}));
//# sourceMappingURL=ShipmentStatus.js.map